angular.module('common.directives.popupMap', [])

    .directive('popupMap', function ($document, $window, $compile) {
        return {
            restrict: 'A',
            scope: {
                mapWidth: '@mapWidth',
                mapHeight: '@mapHeight',
                mapTitle: '@mapTitle',
                mapCentreCoordinates: '=?mapCentreCoordinates',
                mapMarkers: '=?mapMarkers'
            }, 
            controller: 'PopupMapController',
            controllerAs: 'PopupMapController',
            link: function (scope, element, attrs, parentCtrl) {
                if (!element || !element[0]) return;

                element.removeAttr('popup-map'); // necessary to avoid infinite compile loop

                //Compile original element with its scope
                var originalElementUpdated = $compile(element.outerHtml())(scope.$parent);

                //Replace the original element with the updated element with attached click handler to bring up the map window
                element.replaceWith(originalElementUpdated);

                angular.element(originalElementUpdated).on('click', scope.bringUpMapWindow);

                scope.mapWindowOptions = {
                    title: scope.mapTitle,
                    animation: om.config.kendoWindowDefaultOptions.animation,
                    width: scope.mapWidth,
                    height: scope.mapHeight,
                    modal: true,
                    visible: false,
                    resizable: false,
                    actions: ["Close"],
                    deactivate: function (e) {
                        if (scope.map) {
                            scope.map.setTarget(null);
                            scope.map = void 0;
                        }
                    }
                };

                //We are creating kendo window dynamically here instead of compiling it against the scope to avoid strange issues
                //when objects added to the DOM (i.e. hidden window) are rendered by angular to the page breaking the DOM even visually
                var mapWindowElement = $('#omMapWindow');
                if (!mapWindowElement || mapWindowElement.length === 0) {
                    mapWindowElement = $('<div id="omMapWindow" style="padding:0.2em !important;">' +
                        '<div class="om-popup-map"><div id="om-map" class="om-map"><div id="mapInternalPopup"></div></div></div>' +
                        + '</div>')
                        .appendTo('body'); //Create DOM element to hold window

                    mapWindowElement.kendoWindow(scope.mapWindowOptions); //Create kendo window object

                    scope.omMapWindow = $("#omMapWindow").data("kendoWindow"); //Remember reference to the created kendo window object
                }
                
                scope.mapWindowElement = mapWindowElement;
            }
        };
    })

    .controller('PopupMapController', function ($scope, $element, $timeout) {

        _.extend($scope, {
            doMapResize: doMapResize,
            bringUpMapWindow: bringUpMapWindow
        });

        initController();

        function initController() {
            
            $scope.$on("$destroy", function () {
                destroy();
            });
        }

        /**
         * Controller destructor
         */
        function destroy() {

            if ($scope.map) {
                $scope.map.setTarget(null);
                $scope.map = void 0;
            }
            if ($scope.omMapWindow) {
                $scope.omMapWindow.destroy();
                $scope.omMapWindow = void 0;
            }

            if ($scope.mapWindowElement) {
                $scope.mapWindowElement.remove();
            }
        }

        function bringUpMapWindow() {

            $scope.omMapWindow.title($scope.mapTitle);
            $scope.omMapWindow.center().open();

            mapInitInternal();

            $timeout(function () {
                $scope.map.updateSize();
            });
        }

        function getAccentColor() {
            var defaultColor = '#32A9D9'; //default OM accent color

            if ($scope.omMapWindow) {
                //Get the om-map css applied color, which is compiled from less current theme's accent color
                var omMapContainerDiv = $scope.omMapWindow.element.find('.om-map');

                return omMapContainerDiv && omMapContainerDiv.length > 0 ? omMapContainerDiv.css('color') : defaultColor;
            }

            return defaultColor;
        }

        function mapInitInternal() {
            var markers = [];

            if ($scope.mapMarkers && $scope.mapMarkers.length > 0) {
                markers = _.map(_.filter($scope.mapMarkers, function (mm) { return mm !== null; }),
                    function(place) {
                        return new ol.Feature({
                            geometry: new ol.geom.Point(ol.proj.fromLonLat([place.lon, place.lat]))
                        });
                    });
            }

            var tileLayer = new ol.layer.Tile({
                source: new ol.source.OSM()
            });

            var vectorLayer = new ol.layer.Vector({
                source: new ol.source.Vector({
                    features: markers
                }),
                style: new ol.style.Style({
                    image: new ol.style.Icon({
                        scale: 0.2,
                        anchor: [0.5, 0],
                        anchorOrigin: 'bottom-left',
                        anchorXUnits: 'fraction',
                        anchorYUnits: 'fraction',
                        src: 'assets/images/map-marker.png',
                        color: getAccentColor()
                    })
                })
            });

            var firstMarker = $scope.mapMarkers && $scope.mapMarkers.length > 0 ? $scope.mapMarkers[0] : null;
            var mapView = new ol.View({
                center: firstMarker ? ol.proj.fromLonLat([firstMarker.lon, firstMarker.lat]) : ol.proj.fromLonLat([0, 50]),
                zoom: firstMarker ? 17 : 0
            });

            //Create map if not created yet
            if (!$scope.map) {
                var attribution = new ol.control.Attribution({ collapsible: false });


                $scope.map = new ol.Map({
                    target: 'om-map',
                    controls: ol.control.defaults.defaults({ attribution: false }).extend([attribution]),
                    constrainResolution: true
                });
            } 

            $scope.map.addLayer(tileLayer);
            $scope.map.addLayer(vectorLayer);

            //Set map view
            $scope.map.setView(mapView);
        }
        
        function doMapResize() {
            //TODO: Add implementation to resize map in case modal map window is resizable
        }
    })
;
